// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "hotelfinder" + "." + "3605f12d096ff463a5e4" + ".css";
};